
define('text!templates/modules/questionnaire/responses/response-list.html',[],function () { return '<div class="panel-body results-content">\n    <ul class="menu-actions nav nav-pills"></ul>\n\n    <div id="search-member" class="search-placeholder" style="display:none;"></div>\n\n    <div class="alert-list"></div>\n\n    <div id="answered-list"></div>\n</div>\n';});

